import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {vec3} from 'gl-matrix';
import {ActiveCamera} from './active-camera.js';
import {InspectWorld} from './inspect-world.js';

/**
 * menu
 */
export class Menu extends Component {
    static TypeName = 'menu';
    /* Properties that are configurable in the editor */
    @property.object()
    menuObj?: Object3D;

    @property.object()
    menuObj2?: Object3D;

    @property.object()
    player?: Object3D;

    private inspecting = false;
    private headObject: Object3D | undefined;
    private location = vec3.create();
    private forward = vec3.create();
    private headLocation = vec3.create();

    start() {
        /* Validate Properties */
        if (!this.menuObj) {
            throw new Error(`menu(${this.object.name}):menuObj is not defined`);
        }
        if (!this.menuObj2) {
            throw new Error(`menu(${this.object.name}):menuObj2 is not defined`);
        }
        if (!this.player) {
            throw new Error(`menu(${this.object.name}):player is not defined`);
        }

        /* General */
        this.inspecting = false;
        this.headObject = this.player.getComponent(ActiveCamera)?.getActiveCamera();

        /* Controllers */
        window.addEventListener('keydown', this.pressStart.bind(this));
    }

    pressStart(e: KeyboardEvent) {
        if (e.key !== 'Escape') return;

        const inspectWorld = this.object.getComponent(InspectWorld);
        if (!inspectWorld) {
            console.error('InspectWorld not found');
            return;
        }
        if (!this.inspecting) {
            inspectWorld.enterInspectWorld(this.menuObj!, [40, 0, 0]).catch(console.error);
            this.setTransformInfrontOf(this.object, this.menuObj2!);
        } else {
            inspectWorld.exitInspectWorld(this.menuObj!).catch(console.error);
        }

        this.inspecting = !this.inspecting; /* toggle */
    }

    setTransformInfrontOf(
        a: Object3D,
        b: Object3D,
        distance = 1,
        height = 0
        // rotOffset = [0, 0, 0],
        // locOffset = [0, 0, 0]
    ) {
        /* Set Transform of 'b' Object infront of 'a' Object */
        this.location = [0, 0, 0];
        this.forward = [0, 0, 0];
        this.headLocation = [0, 0, 0];
        a.getPositionWorld(
            this.location
        ); /* Get 'a' location to output result in 'this.location' */
        this.headObject!.getForwardWorld(
            this.forward
        ); /* Using 'headObject' to appear in Player's looking direction */
        this.headObject!.getPositionWorld(this.headLocation);

        /* Temporarly semi-fix middle bug when looking too down/up */
        this.forward[1] = 0; //No rotation up or down
        vec3.normalize(this.forward, this.forward);

        /* Location */
        this.location[0] += this.forward[0] * distance; /* Combine Location with Forward */
        this.location[1] = this.headLocation[1] + height; /* Set Location Height to Head */
        this.location[2] += this.forward[2] * distance; /* Combine Location with Forward */
        b.setPositionWorld(this.location); /* Set 'b' to 'a' location */

        /* Rotation */
        a.getPositionWorld(this.location); /* Get new location */
        this.location[1] -= 1.5; // Sketchy lowering height to player's eyes
        //b.lookAt(this.location, [0, 1, 0]); /* Rotate 'b' towards 'a' */
        //this.object.lookAt

        // b.rotationWorld = this.locInspectedObj.rotationWorld;
        // b.rotateAxisAngleDegObject([1, 0, 0], rotOffset[0]); /* Offset X */
        // b.rotateAxisAngleDegObject([0, 1, 0], rotOffset[1]); /* Offset Y */
        // b.rotateAxisAngleDegObject([0, 0, 1], rotOffset[2]); /* Offset Z */

        //Bug: When looking too down/up and transform object infront of you, the object doesn't become in the middle
    }
}
